<template>

  <el-row :gutter="5">
    <el-col :span="4"></el-col>
    <el-col :span="16"><h2 class="heading">ISS Meeting Report</h2></el-col>
    <el-col :span="4"></el-col>
  </el-row>

  <el-row :gutter="5">
    <el-col :span="4" style="text-align: center;"><span style="color:#888;font-size:14px;">Total Records: <b>{{topHoldingBallots.length}}</b></span></el-col>
    <el-col :span="16" style="text-align: center;">
        <span class="label">ETF</span>
        <el-select v-model="fund" placeholder="Select ETF" @change="query()" style="width:150px;" clearable>
            <el-option label="All ETFs" value=""></el-option>
            <el-option label="2803" value="2803"></el-option>
            <el-option label="3173" value="3173"></el-option>
            <el-option label="3151" value="3151"></el-option>
            <el-option label="3181" value="3181"></el-option>
            <el-option label="2810" value="2810"></el-option>
            <el-option label="2804" value="2804"></el-option>
			<el-option label="3453" value="3453"></el-option>
        </el-select>

        <span class="label">Top</span>
        <el-select v-model="topNo" placeholder="Select nature" @change="query()" style="width:150px;" clearable>
            <el-option label="All Holdings" value="1000"></el-option>
            <el-option v-for="top in tops" :key="top" :label="top" :value="top"></el-option>
        </el-select>

        <span class="label">Meeting Date</span>
        <el-date-picker v-model="startDate" type="date" placeholder="Start Date" value-format="YYYY-MM-DD" style="width:150px;"/><span style="color:#888"> - </span>
        <el-date-picker v-model="endDate" type="date" placeholder="End Date" value-format="YYYY-MM-DD" style="width:150px;"/>

        <el-button type="primary" style="margin-left:20px;" @click="query()">OK</el-button>
    </el-col>
    <el-col :span="4"></el-col>
  </el-row>
  
  <el-table :data="topHoldingBallots" height="88%" style="width:95%; margin:15px auto;" 
        :default-sort="{ prop: prop, order: order }" >
    <el-table-column prop="fund" label="ETF" align="center" width="50" />
    <el-table-column prop="stockCode" label="Ticker" width="80" />
    <el-table-column prop="nameCn" label="NameCN" />
    <el-table-column prop="nameEn" label="NameEN" width="350" />
    <el-table-column prop="weighting" label="Weight" align="center">
        <template #default="scope">{{global.number_format(scope.row.weighting, 2)}}%</template>
    </el-table-column>
    <el-table-column prop="topNo" label="TopNo" align="center" />
    <el-table-column prop="votableShares" label="Shares" align="center"/>
    <el-table-column prop="meetingDate" label="MeetingDate" />
    <el-table-column prop="recordDate" label="RecordDate" width="100" />
    <el-table-column prop="ballotCutoffDate" label="CatoffDate" align="center" />
    <el-table-column prop="proposalCount" label="Agendas" align="center"/>
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="https://secure.issgovernance.com/AuthApp/" target="_blank" title="Vote" class="op">
                Vote
            </a>
            <el-icon :size="16" @click="$router.push('/iss/viewMeetingDetails?meetingId=' + scope.row.meetingId + '&ballotId=' + scope.row.ballotId)" style="cursor:pointer" 
                title="View details" class="op"><document />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { Document, Search, Delete, Edit } from '@element-plus/icons-vue'

export default {
    components: {
        Document
    },
    data() {
        return {
            fund: "",
            topNo: null,
            startDate: global.dateToString(new Date()),
            endDate: null,
            tops : [10, 20, 50, 100],
            topHoldingBallots: [],
            errMsg: '',
            global,
        }
    },
    async mounted() {
        console.log(new Date().toDateString());
        this.global.index = "iss";
        this.currentUser = this.global.currentUser;
        this.query();
    },
    methods: {
        async query() {
            let data = {};
            if (this.fund) data["fund"] = this.fund;
            if (this.topNo) data["topNo"] = this.topNo;
            if (this.startDate) data["startDate"] = this.startDate;
            if (this.endDate) data["endDate"] = this.endDate;

            console.log(data);

            let result = await AXIOS("/iss/getAllHoldingBallots", data);
            if (result.success) {
                this.topHoldingBallots = result.data;
            } else {
                this.errMsg = result.errMsg;
            }
        }
    }
}
</script>

<style>
    .label {padding-left:20px;}
</style>